import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Button, { ButtonProps } from '../button';
import RightArrow from '@components/basics/icons/right-arrow';
import LoadingCtrl from '@webapp/controllers/loading';

interface ButtonArrowProps extends ButtonProps {
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const ButtonArrow: FunctionComponent<ButtonArrowProps> = ({
  className,
  disabled,
  isLoading,
  ...props
}) => {
  return (
    <Button
      className={className || ''}
      disabled={disabled}
      buttonType="primary"
      onClick={props.onClick}
      customContent={
        isLoading ? (
          <LoadingCtrl
            className={`loading-animation ${isLoading ? 'is-loading' : ''}`}
            loading={isLoading}
            isSVG
          />
        ) : (
          <RightArrow
            isWhite={!disabled}
            className={`arrow ${disabled ? 'disabled' : ''}`}
          />
        )
      }
    />
  );
};

export default styled(ButtonArrow)`
  position: relative;
  width: 78px;
  min-height: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  flex: auto;
  max-height: none;

  .arrow {
    &.disabled {
      path {
        fill: ${({ theme }) => theme.colors.tertiary};
      }
    }
  }

  .loading-animation {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    opacity: 0;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &.is-loading {
      opacity: 1;
    }

    svg {
      path {
        fill: ${({ theme }) => theme.colors.differentBackground};
      }
    }
  }
`;
